export default {
    list_agents: 'Search by Name or E-mail',
    list_customers: 'Search by Name, E-mail or Organization',
    list_calls: 'Search by Number or Title',
    list_tasks: 'Search by Number, Title or Description',
    list_attendance_groups: 'Search by Name or Organization',
    list_sla_config: 'Search by Service Group or Category',
    list_organizations: 'Search by Name, Website or Phone',
    by_name_or_description: 'Search by Name or Description',
    by_description: 'Search by Description',
    by_name: 'Search by Name',
    by_title_or_content: 'Search by Title or Content',
}
